import { render, staticRenderFns } from "./ThePartnerSelectorList.vue?vue&type=template&id=47952bed&scoped=true"
import script from "./ThePartnerSelectorList.vue?vue&type=script&lang=ts"
export * from "./ThePartnerSelectorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47952bed",
  null
  
)

export default component.exports